import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageMediaList
 * @description
 * # manageMediaList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageMediaList', ($ngRedux, $scope, $rootScope, $location, $route, $http, ENV) => {
    if (!$scope.isSuperUser && !$scope.isAdminUser) {
      $location.path('/');
    }

    $scope.processParams = () => {
      const { mediaId } = $route.current.params;
      if (mediaId) {
        $scope.getMediaInfo($http, ENV, mediaId).then((media) => {
          $scope.reviewMedia(media);
        });
      }
    };

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.media;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.listRetryMediaFile = (mediaId) => {
      $scope.retryMediaFile($http, ENV, mediaId)
        .then((response) => {
            $scope.getData();
        })
        .catch((err) => {
          console.warn(err);
        });
    };

    $scope.deleteMediaRecord = (mediaId) => {
      $scope
        .deleteMedia($http, ENV, mediaId)
        .then(() => {
          $scope.getData();
        })
        .catch((err) => {
          console.warn(err);
        });
    };

    $scope.confirmDeleteMedia = (mediaId) => {
      $rootScope.showErrorModal = true;
      $rootScope.errorModalOptions = {
        heading: 'Delete Media?',
        message: `Are you sure you wish to delete this record?  This action cannot be undone.`,
        buttons: [
          {
            label: 'Confirm',
            href: '#',
            clickFn: () => {
              $scope.deleteMediaRecord(mediaId);
              $rootScope.showErrorModal = false;
            },
          },
          {
            label: 'Cancel',
            href: '#',
            clickFn: () => {
              $rootScope.showErrorModal = false;
            },
          },
        ],
      };
    };

    $scope.reviewMedia = (media) => {
      $location.path(`/admin/media/manage-media/${media.id}`, false);
      $scope.showMediaDetail({ media: media, userId: media.user.id });
    };

    $scope.getAge = (date) => {
      const today = new Date();
      const birthDate = new Date(date);
      const flag = today.getMonth() - birthDate.getMonth();
      let age = today.getFullYear() - birthDate.getFullYear();

      if (flag < 0 || (flag === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1;
      }

      return age;
    };

    $scope.processApplicationName = (application) => {
      if (application === 'Tigger Application') {
        return 'Cat Pain IQ Application';
      }
      if (application === 'Solensia IEP Application') {
        return 'Experience Solensia Application';
      }
      return application;
    };

    $scope.table = {
      name: 'Manage Media',
      options: {
        endpoint: '/1.0/media/files/',
        endpoint_data_key: 'files',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'standard',
        scale_up: false,
        search_key: 'media',
        search_required: false,
      },
      columns: [
        {
          name: 'File',
          options: {
            content: `
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-file-earmark-play-fill"
                viewBox="0 0 16 16"
                style="width: 67px; height: 50px"
                ng-if="!record.thumbnail"
              >
                <path
                  fill-rule="evenodd"
                  d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z"
                />
              </svg>
              <img
                ng-if="!!record.thumbnail"
                ng-src="{{record.thumbnail}}"
                alt="Video thumbnail"
                style="width: 105px; height: 60px"
              />
              <p style="line-height: 0.8rem">{{ record.name }}<p>
            `,
          },
        },
        {
          name: 'Pet and Owner',
          options: {
            content: `
              <span>
                <span
                  href="#"
                  ng-if="record.user.first_name || record.user.last_name"
                  ng-href="#"
                >
                  {{record.user.last_name}}, {{record.user.first_name}}
                </span>
                <span
                  href="#"
                  ng-if="!record.user.first_name && !record.user.last_name"
                  ng-href="#"
                >
                  {{record.user.email}}
                </span>
              </span>

              <span
                ng-href="#" class="name-link"
              >
                {{record.pets[0].name}}
                <span
                  style="color: black; font-size: 14px; font-weight: normal"
                  ng-if="record.pet[0].is_active == false || record.pet[0].status == 'Deleted'"
                >
                  (ARCHIVED)
                </span
              >
              </span>
              <span class="line-wrapper small">
                <span ng-if="record.pets[0].is_male">Male: </span>
                <span ng-if="!record.pets[0].is_male">Female: </span>
                <span ng-if="record.pets[0].date_of_birth">
                  {{getAge(record.pets[0].date_of_birth)}}&nbsp;years old
                </span>
                <span ng-if="!record.pets[0].date_of_birth">Unknown Age</span>
              </span>
              <span class="line-wrapper small">
                {{breedLookup(record.pets[0].breed)}}
              </span>
            `,
            class: '',
          },
        },
        {
          name: 'Application',
          options: {
            content: `
              <div ng-repeat="category in record.categories">
                <span ng-if="category.name">{{processApplicationName(category.name)}}</span>
              </div>
            `,
            class: '',
          },
        },
        {
          name: 'Date Updated',
          options: {
            content: `{{ record.updated | dateInMMDDYYYWithHyphen }}`,
            class: '',
          },
        },
        {
          name: 'Status',
          options: {
            content: '{{ record.status }}',
            class: '',
          },
        },
        {
          name: 'Action',
          options: {
            content: `
              <a ng-click="reviewMedia(record)" href="#" class="orange-link">Review</a><br><a ng-click="confirmDeleteMedia(record.id)" href="#" class="orange-link">Delete</a><br ng-if="!record.file_name && record.mime_type && record.azure_source" /><br ng-if="!record.file_name && record.mime_type && record.azure_source" /><a href="#" ng-click="listRetryMediaFile(record.id)" class="orange-link" ng-if="!record.file_name && record.mime_type && record.azure_source">Retry Processing</a>`,
            class: 'orange-link',
          },
        },
      ],
      filters: [
        {
          name: 'Organizations',
          type: 'angucomplete',
          options: {
            class: 'organization-filter',
            query_string_parameter: 'organization',
            remove_all: true,
            remove_all_key: 'organizations',
            search_endpoint: '/2.0/organizations/',
            search_endpoint_data_key: 'data',
            selected: [],
            selected_key: ['name'],
            selected_remove_key: 'id',
          },
          angucomplete_parameters: {
            id: 'organization-name',
            placeholder: 'Organization Name',
            pause: 1000,
            datafield: 'organizations',
            isclearafterselect: true,
            selectedobject: 'name',
            searchfields: 'name',
            titlefield: 'name',
            descriptionfield: null,
            minlength: 2,
            inputclass: 'form-control form-control-small',
            matchclass: 'highlight',
            searchfn: $scope.filterOrganizations,
            nextfn: $scope.filterOrganizationsPage,
            onselect: $scope.setSelectedOrganizations,
            preselected: [],
            isUser: false,
          },
        },
        {
          name: 'Media Type',
          type: 'multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/1.0/media/types/',
            choices_endpoint_data_key: 'types',
            class: 'application-filter',
            name_attribute: 'name',
            query_string_parameter: 'types',
            select_all: true,
          },
        },
        {
          name: 'Applications',
          type: 'multiple_choice',
          options: {
            choices: {
              'Cat Pain IQ': { state: true, value: 1, order: 0 },
              'Experience Solensia': { state: true, value: 2, order: 1 },
              'Experience Librela': { state: true, value: 4, order: 2 },
              'Mobile Application': { state: true, value: 3, order: 3 },
            },
            class: 'above-divider',
            query_string_parameter: 'categories',
            select_all: true,
          },
        },
        {
          name: 'Status',
          type: 'multiple_choice',
          options: {
            choices: {
              created: { state: true, value: 'created', order: 0 },
              failure: { state: true, value: 'failure', order: 1 },
              submitted: { state: true, value: 'submitted', order: 2 },
              success: { state: true, value: 'success', order: 3 },
              thumbnail_generation_error: {
                state: true,
                value: 'thumbnail_generation_error',
                order: 4,
              },
              transcoding: { state: true, value: 'transcoding', order: 5 },
              transcoding_error: { state: true, value: 'transcoding_error', order: 6 },
              uploading_complete: { state: true, value: 'uploading_complete', order: 7 },
              uploading_error: { state: true, value: 'uploading_error', order: 8 },
              waiting_for_uploading: { state: true, value: 'waiting_for_uploading', order: 9 },
              waiting_for_transcoding: { state: true, value: 'waiting_for_transcoding', order: 10 },
            },
            class: 'application-filter',
            name_attribute: 'status',
            query_string_parameter: 'status',
            select_all: true,
          },
        },
      ],
      sort_options: {
        updated: {
          state: true,
          value: '-1',
          title: 'Date Media Updated',
          order: 0,
        },
        status: {
          state: false,
          value: '-1',
          title: 'Status',
          order: 1,
        },
        categories__name: {
          status: false,
          value: '-1',
          title: 'Application',
          order: 2,
        },
      },
    };

    $scope.init();
  });
